import React from 'react';
import useCondition from '../../useCondition';

export default () => {
  const {condition} = useCondition();

  if (!condition?.capitalFund?.from && !condition?.capitalFund?.to) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">資本金</h4>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
          {condition.capitalFund.from
            ? `${condition.capitalFund.from}万円`
            : '未設定'}
        </span>
        <span className="text-c-light">~</span>
        <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
          {condition.capitalFund.to
            ? `${condition.capitalFund.to}万円`
            : '未設定'}
        </span>
      </div>
    </div>
  );
};
